import React, { FunctionComponent, ReactElement } from 'react';
import { Box } from '@material-ui/core';
import TrimLevelType from '../../../../../trimLevels/enum/TrimLevelType';
import customise from '../../../../constants/customise';
import useIsTablet from '../../../../../common/react/useIsTablet';
import ScrollToWrapper from '../../../presentational/ScrollToWrapper';
import ModelContainer from './trimLevelContainer/ModelContainer';
import VariantContainer from './trimLevelContainer/VariantContainer';
import SpecificationPackContainer from './trimLevelContainer/SpecificationPackContainer';
import { useChangeVariant } from '../../../../hooks/variant/useChangeVariant';

const VariantsSectionContainer: FunctionComponent = () => {
  const isTablet = useIsTablet();
  const variantName = customise.VARIANT_ITEM.name;
  const { selectedVariantId, changeVariant, trimLevelType } = useChangeVariant();

  const CurrentTrimLevelComponent: { [key: string]: ReactElement } = {
    [TrimLevelType.MODEL]: <ModelContainer selectedVariantId={selectedVariantId} changeVariant={changeVariant} />,
    [TrimLevelType.VARIANT]: <VariantContainer selectedVariantId={selectedVariantId} changeVariant={changeVariant} />,
    [TrimLevelType.SPECIFICATION_PACK]: (
      <SpecificationPackContainer selectedVariantId={selectedVariantId} changeVariant={changeVariant} />
    ),
  };

  if (trimLevelType === undefined) {
    return null;
  }

  return (
    <Box pb={6} pt={!isTablet ? 6 : 0} data-test={`variants_section:${trimLevelType}`}>
      <ScrollToWrapper target={variantName}>
        {CurrentTrimLevelComponent[trimLevelType as TrimLevelType]}
      </ScrollToWrapper>
    </Box>
  );
};

export default VariantsSectionContainer;
